export default __webpack_public_path__ + "static/media/search-icon.afb97305.svg";